import axios from 'axios'

import { getBaseHref } from '../shared/env'
import { escHtml } from '../shared/utils'


/* Elements */
let wrapperEl
let buttonOpenEls
let formEl
let buttonCloseEl
let stepFormEl
let stepConfirmEl
let stepSentEl
let confirmValueProductBrandEl
let confirmValueProductNameEl
let confirmValueProductSerialNumEl
let confirmValueCommentEl
let confirmBtEl
let notConfirmBtEl
let acceptBtEl
let controlWrapperEls
let errorMessageEl
let ticketCodeEl

/* Error message */
let errorMessageFieldErrors
let errorMessageNotLogged
let errorMessageGeneral

/* State vars */
let isOpen = false
let loading = false

document.addEventListener('DOMContentLoaded', () => {
    onDomContentLoaded()
})

const onDomContentLoaded = () =>
{
    /* Find essential elements */
    wrapperEl = document.querySelector('.lib-support-ticket-form-modal')
    buttonOpenEls = document.querySelectorAll('[rel="lib-support-ticket-form-modal"]')

    /* If found, init form */
    if (wrapperEl !== null && buttonOpenEls.length > 0)
    {
        initForm()
    }
}

const initForm = () =>
{
    /* Find inner elements */
    formEl = wrapperEl.querySelector('form')
    buttonCloseEl = wrapperEl.querySelector('.button-close')
    stepFormEl = wrapperEl.querySelector('.step-form')
    stepConfirmEl = wrapperEl.querySelector('.step-confirm')
    stepSentEl = wrapperEl.querySelector('.step-sent')
    confirmValueProductBrandEl = stepConfirmEl.querySelector('.confirm-value-product-brand')
    confirmValueProductNameEl = stepConfirmEl.querySelector('.confirm-value-product-name')
    confirmValueProductSerialNumEl = stepConfirmEl.querySelector('.confirm-value-product-serial-num')
    confirmValueCommentEl = stepConfirmEl.querySelector('.confirm-value-comment')
    confirmBtEl = stepConfirmEl.querySelector('.button-confirm')
    notConfirmBtEl = stepConfirmEl.querySelector('.button-not-confirm')
    acceptBtEl = stepSentEl.querySelector('.button-accept')
    controlWrapperEls = wrapperEl.querySelectorAll('.control-wrapper')
    errorMessageEl = wrapperEl.querySelector('.footer .error-message')
    ticketCodeEl = stepSentEl.querySelector('.ticket-code')

    /* Error messages */
    errorMessageFieldErrors = formEl.dataset.errorMessageFieldErrors
    errorMessageNotLogged = formEl.dataset.errorMessageNotLogged
    errorMessageGeneral = formEl.dataset.errorMessageGeneral

    /* Event for opening buttons */
    buttonOpenEls.forEach(buttonOpenEl =>
    {
        buttonOpenEl.addEventListener('click', openModal)
    })

    /* Do not bubble form clicks to outside */
    formEl.addEventListener('click', (event) => { event.stopPropagation() })

    /* Event for various steps */
    wrapperEl.addEventListener('click', closeModal)
    buttonCloseEl.addEventListener('click', closeModal)
    formEl.addEventListener('submit', (event) => { submitForm(false, event, stepConfirmEl) })

    /* Events for step confirm */
    confirmBtEl.addEventListener('click', () => { submitForm(true, null, stepSentEl) })
    notConfirmBtEl.addEventListener('click', () => { setStepEl(stepFormEl) })

    /* Events for step sent */
    acceptBtEl.addEventListener('click', closeModal)
}

const openModal = () =>
{
    isOpen = true
    wrapperEl.classList.remove('display-none')
}

const closeModal = () =>
{
    isOpen = false
    wrapperEl.classList.add('display-none')
    markFieldErrors([])
    setErrorMessage('')
    
    /* If sent, clear form on close */
    if (stepSentEl.classList.contains('active'))
    {
        formEl.reset()
        setTicketCode('')
    }

    /* Then set the first step */
    setStepEl(stepFormEl)
}

const submitForm = (commit, event, nextStepEl) =>
{
    /* If event is provided, prevent default behavior */
    if (event)
    {
        event.preventDefault()
    }

    /* The form data */
    const formData = new FormData(formEl)

    /* Update confirm step values */
    confirmValueProductBrandEl.innerHTML = escHtml(formData.get('product_brand'))
    confirmValueProductNameEl.innerHTML = escHtml(formData.get('product_name'))
    confirmValueProductSerialNumEl.innerHTML = escHtml(formData.get('product_serial_num'))
    confirmValueCommentEl.innerHTML = escHtml(formData.get('comment'))

    /* Commit or not */
    let url
    url = getBaseHref() + 'ajax/lib-support-ticket-form-modal/submit' +
        (commit ? '?commit=1' : '')
     
    /* Just send form data */
    markFieldErrors([])
    setErrorMessage('')
    setLoading(true)
    axios.post(url, new FormData(formEl))
        .then((ajaxResponse) => {
            setLoading(false)
            setTicketCode(ajaxResponse.data.ticketCode)
            setStepEl(nextStepEl)
        })
        .catch((error) => {
            setLoading(false)
            if (error.response && error.response.status == 422) {
                const data = error.response.data
                markFieldErrors(data.fieldErrors);
                setErrorMessage(errorMessageFieldErrors);
            } else if (error.response && error.response.status == 401) {
                setErrorMessage(errorMessageNotLogged)
            } else  {
                setErrorMessage(errorMessageGeneral)
                console.log(error)
            }
            setStepEl(stepFormEl)
        })
}

const markFieldErrors = (fieldErrors) =>
{
    for (const controlWrapperEl of controlWrapperEls)
    {
        const controlEl = controlWrapperEl.classList.contains('checkboxes-wrapper') ?
            controlWrapperEl : controlWrapperEl.querySelector('input, textarea, select')
        const errorMessageEl = controlWrapperEl.querySelector('.error-message')
        if (controlEl && fieldErrors[controlWrapperEl.dataset.name])
        {
            controlWrapperEl.classList.add('error')
            if (errorMessageEl) {
                errorMessageEl.innerHTML = escHtml(fieldErrors[controlWrapperEl.dataset.name])
            }
        }
        else
        {
            controlWrapperEl.classList.remove('error')
        }
    }
}

const setLoading = (newLoading) =>
{
    if (newLoading != loading)
    {
        loading = newLoading;
        if (loading)
        {
            wrapperEl.classList.add('loading')
        }
        else
        {
            wrapperEl.classList.remove('loading')
        }
    }
}

const setStepEl = (stepEl) =>
{
    for (const step of [stepFormEl, stepConfirmEl, stepSentEl])
    {
        step.classList.remove('active')
    }
    stepEl.classList.add('active')
}

const setErrorMessage = (message) =>
{
    errorMessageEl.innerHTML = message
    errorMessageEl.classList.toggle('display-none', !message)
}

const setTicketCode = (ticketCode) =>
{
    ticketCodeEl.innerHTML = escHtml(ticketCode)
}

